/* eslint-disable react/require-default-props */
import React, { useRef, useState, useCallback } from 'react';
import { Button } from '@ui/atoms/Button';
import { Popup } from '../Popup';
const DEFAULT_LABEL = 'More';
/**
 * ToolbarOverflow Component
 * Renders an ellipsis button that opens a popup containing overflowed toolbar items.
 */
export function ToolbarOverflow({ overflowChildren, moreActionsLabel = DEFAULT_LABEL }) {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const handleToggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);
    const handleItemClick = useCallback(() => {
        setOpen(false);
    }, []);
    return (React.createElement("div", { className: "qmb-ui-toolbar__overflow" },
        React.createElement(Button, { ref: anchorRef, type: "button", className: "", onClick: handleToggle, title: moreActionsLabel, "aria-label": moreActionsLabel, "aria-haspopup": "true", "aria-expanded": open },
            React.createElement("i", { className: "fa-light fa-ellipsis" }),
            moreActionsLabel),
        React.createElement(Popup, { anchor: anchorRef.current, show: open, onClose: handleClose, position: "bottom-right" },
            React.createElement(Popup.Section, null,
                React.createElement(Popup.ActionList, null, overflowChildren.map((child, index) => (
                // eslint-disable-next-line react/no-array-index-key, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                React.createElement("span", { key: index, onClick: handleItemClick }, child))))))));
}
